import { useState, useEffect } from "react";
import Left from "./Left";
import Center from "./Center";
import Right from "./Right";
import "./Terms.scss";

export default function Terms() {
  const [currentPolicy, setCurrentPolicy] = useState("generalPrivacy");

  // 👇 Scroll to top when component mounts
  useEffect(() => {
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: "smooth", // or "auto" for instant
    });
  }, []);

  return (
    <div className="policy-layout flex">
      <Left currentPolicy={currentPolicy} setCurrentPolicy={setCurrentPolicy} />
      <Center currentPolicy={currentPolicy} />
      <Right currentPolicy={currentPolicy} />
    </div>
  );
}
